import React, { Component } from 'react'
import { Query } from 'react-apollo'
import gql from 'graphql-tag'
import InfiniteScroll from 'react-infinite-scroller'
import Input from 'components/Input'

import Loader from 'components/Loader'
import { Container, Header, Button, Table } from 'semantic-ui-react'

export class ConditionsList extends Component {
  state = {
    limit: 50,
    offset: 0,
    query: '',
    hasMore: true,
  }

  handleSearch = event => {
    this.setState({ query: event.target.value })
  }

  renderRow = ({ id, name, info }) => {
    return (
      <Table.Row key={id}>
        <Table.Cell>{name}</Table.Cell>
        <Table.Cell>{info}</Table.Cell>
      </Table.Row>
    )
  }

  renderTable() {
    const { limit, offset, query, hasMore } = this.state
    const variables = { limit, offset, query }
    return (
      <Query query={CONDITIONS_QUERY} variables={variables}>
        {({ data, loading, error, fetchMore }) => {
          if (loading) {
            return <Loader />
          }

          if (error) {
            console.error(error.message)
            return (
              <div style={{ color: 'red' }}>
                <p> Error fetching conditions: {error.message}</p>
                {error.graphQLErrors.map(gqlError => (
                  <span>{gqlError.message}</span>
                ))}
              </div>
            )
          }

          return (
            <InfiniteScroll
              loadMore={() =>
                fetchMore({
                  variables: { offset: data.conditions.length },
                  updateQuery: (prev, { fetchMoreResult, variables }) => {
                    if (!fetchMoreResult) return prev
                    if (!fetchMoreResult.conditions.length) {
                      this.setState({ hasMore: false })
                    }
                    return {
                      ...prev,
                      conditions: [
                        ...prev.conditions,
                        ...fetchMoreResult.conditions,
                      ],
                    }
                  },
                })
              }
              hasMore={hasMore}
              loader={<Loader />}
            >
              <Table fixed singleLine>
                <Table.Header>
                  <Table.Row>
                    <Table.HeaderCell width={4}>Name</Table.HeaderCell>
                    <Table.HeaderCell>Info</Table.HeaderCell>
                  </Table.Row>
                </Table.Header>

                <Table.Body>{data.conditions.map(this.renderRow)}</Table.Body>
              </Table>
            </InfiniteScroll>
          )
        }}
      </Query>
    )
  }

  render() {
    return (
      <Container>
        <Header as="h1">All Conditions</Header>

        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <Input
            icon="medkit"
            placeholder="Search Conditions..."
            minLength={2}
            debounceTimeout={300}
            onChange={this.handleSearch}
          />
          <Button
            primary
            onClick={() => this.props.history.push('/conditions/suggested')}
          >
            Suggested Conditions
          </Button>
        </div>

        {this.renderTable()}
      </Container>
    )
  }
}

export const CONDITIONS_QUERY = gql`
  query ConditionsQuery($limit: Int, $offset: Int, $query: String) {
    conditions(limit: $limit, offset: $offset, query: $query) {
      id
      name
      info
    }
  }
`

export default ConditionsList
